<template>
  <div
    class="flex items-center justify-between p-2"
    :class="item.page ? 'cursor-pointer' : 'cursor-auto'"
    @click="handleItemSelection"
  >
    <h4 class="font-normal text-body-color">
      {{ formatTitle(item.is_type) }}
    </h4>

    <img
      v-if="item.is_excluded"
      class="h-5"
      src="@/assets/exclamation-red.svg"
      alt="exclamation icon"
    />

    <img
      v-else
      class="h-5"
      src="@/assets/checkmark-gray.svg"
      alt="checkmark icon"
    />
  </div>
  <div
    v-if="isSelected"
    class="flex cursor-auto flex-col gap-1 px-2 pb-4 pt-6 text-xs"
  >
    <div v-if="item.referenced_text">
      <p class="pb-1 uppercase text-body-color">Reference</p>
      <p class="text-body-color">"{{ item.referenced_text }}"</p>
    </div>
    <div v-else>
      <p class="text-body-color">
        Item was not explicitly listed as an exclusion in the policy
      </p>
    </div>
    <p
      v-if="item.page"
      class="text-body-color"
    >
      Page {{ item.page }}
    </p>
    <!-- <a -->
    <!--   v-if="item.page" -->
    <!--   class="text-yellow-600" -->
    <!--   target="_blank" -->
    <!--   :href="`${attachmentUrl}#page=${item.page}`" -->
    <!-- > -->
    <!--   Page {{ item.page }} -->
    <!-- </a> -->
  </div>
</template>

<script>
export default {
  name: 'Exclusion Details',
  props: {
    item: Object,
    isSelected: Boolean,
    attachmentUrl: String,
  },
  emits: ['click'],
  methods: {
    formatTitle(title) {
      const text = title?.replace(/_/g, ' ');

      return this.capitalizeWords(text);
    },
    capitalizeWords(text, options = {}) {
      if (typeof text === 'string' && text.length) {
        const string = text.toLowerCase().trim();
        if (options.firstOnly) {
          return string?.charAt(0)?.toUpperCase() + string?.slice(1);
        }
        return string
          ?.split(' ')
          .map((word) =>
            this.fixMc(word.charAt(0)?.toUpperCase() + word.slice(1))
          )
          .join(' ');
      }
      return '';
    },
    fixMc(str) {
      return str.replace(/\bMc(\w)/, function (match, p1) {
        return match.slice(0, -1) + p1.toUpperCase();
      });
    },
    handleItemSelection() {
      if (this.item.page) {
        this.$emit('click');
      }
    },
  },
};
</script>
